import React from 'react'
import {GlobalStyles} from '@mui/material'

export default function GlobalFonts() {
    return (
        <GlobalStyles
            styles={`



        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT.ttf') format('truetype');
          font-weight: 400;
          font-style: normal;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-Bold.ttf') format('truetype');
          font-weight: 700;
          font-style: normal;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-BoldOblique.ttf') format('truetype');
          font-weight: 700;
          font-style: italic;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-Book.ttf') format('truetype');
          font-weight: 400;
          font-style: normal;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-BookOblique.ttf') format('truetype');
          font-weight: 400;
          font-style: italic;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-Condensed.ttf') format('truetype');
          font-weight: 400;
          font-style: normal;
          font-stretch: condensed;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-CondensedBold.ttf') format('truetype');
          font-weight: 700;
          font-style: normal;
          font-stretch: condensed;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-CondensedBoldOblique.ttf') format('truetype');
          font-weight: 700;
          font-style: italic;
          font-stretch: condensed;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-CondensedExtraBold.ttf') format('truetype');
          font-weight: 800;
          font-style: normal;
          font-stretch: condensed;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-CondensedLight.ttf') format('truetype');
          font-weight: 300;
          font-style: normal;
          font-stretch: condensed;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-CondensedLightObl.ttf') format('truetype');
          font-weight: 300;
          font-style: italic;
          font-stretch: condensed;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-CondensedOblique.ttf') format('truetype');
          font-weight: 400;
          font-style: italic;
          font-stretch: condensed;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-CondExtraBoldObl.ttf') format('truetype');
          font-weight: 800;
          font-style: italic;
          font-stretch: condensed;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-ExtraBold.ttf') format('truetype');
          font-weight: 800;
          font-style: normal;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-ExtraBoldOblique.ttf') format('truetype');
          font-weight: 800;
          font-style: italic;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-Heavy.ttf') format('truetype');
          font-weight: 900;
          font-style: normal;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-HeavyOblique.ttf') format('truetype');
          font-weight: 900;
          font-style: italic;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-Light.ttf') format('truetype');
          font-weight: 300;
          font-style: normal;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-LightOblique.ttf') format('truetype');
          font-weight: 300;
          font-style: italic;
        }




        @font-face {
          font-family: 'Futura LT';
          src: url('${process.env.PUBLIC_URL}/fonts/FuturaLT-Oblique.ttf') format('truetype');
          font-weight: 400;
          font-style: italic;
        }




        @font-face {
          font-family: 'Gloria Hallelujah';
          src: url('${process.env.PUBLIC_URL}/fonts/GloriaHallelujah-Regular.ttf') format('truetype');
          font-weight: 400;
          font-style: normal;
        }
      `}
        />
    )
}
